import { resolveRTCPeerConnection } from 'utils/WebRTCCommon';

export const KNOWN_CODECS: Record<string, string> = {
  H264: 'H264/90000',
  VP8: 'VP8/90000',
  VP9: 'VP9/90000',
  OPUS: 'opus/48000',
};

const RTP_PROFILE_MARKER: RegExp = /a=rtpmap:\d+\s/;

export const extractCodecsFromSDP: ({ sdp }: RTCSessionDescriptionInit) => string[] = ({ sdp }) => {
  if (!sdp) {
    return [];
  }

  const sdpLines: string[] = sdp.split(/\r?\n/);
  const codecsSdpLines: string[] = sdpLines.filter((sdpLine) => sdpLine.match(RTP_PROFILE_MARKER));

  return [...new Set(codecsSdpLines.map((sdpLine) => sdpLine.replace(RTP_PROFILE_MARKER, '')))];
};

export const checkCodecsSupported: (
  mode: 'play' | 'broadcast',
  codecs: string[],
) => Promise<string[]> = async (mode, codecs) => {
  try {
    const direction: RTCRtpTransceiverDirection = mode === 'play' ? 'recvonly' : 'sendonly';
    const RTCPeerConnectionConstructor: typeof RTCPeerConnection = resolveRTCPeerConnection();

    const connection: RTCPeerConnection = new RTCPeerConnectionConstructor({ iceServers: [] });

    if (connection.addTransceiver) {
      connection.addTransceiver('audio', { direction });
      connection.addTransceiver('video', { direction });
    }

    const offerConfig: RTCOfferOptions = {};

    const sdp: RTCSessionDescriptionInit = await connection.createOffer(offerConfig);

    const sdpCodecs: string[] = extractCodecsFromSDP(sdp);

    connection.close();

    return codecs.filter((codec) => sdpCodecs.includes(codec));
  } catch (e) {
    return [];
  }
};
